import { createSlice } from "@reduxjs/toolkit";

export type CargoTypeCode = string;

export type CargoTypeGroup = {
  id: number;
  code: string;
  name: string;
};

export type CargoType = {
  id: number;
  code: CargoTypeCode;
  name: string;
  group: CargoTypeGroup;
};

type InitialState = {
  data: CargoType[];
  isLoading: boolean;
};

const initialState: InitialState = {
  data: [],
  isLoading: false,
};

const cargoTypeSlice = createSlice({
  name: "cargoTypeSlice",
  initialState,
  reducers: {
    fetchData: (state) => {
      state.isLoading = true;
    },
    setData: (state, action) => {
      state.data = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    reset: () => initialState,
  },
});

export default cargoTypeSlice;
